// Contexto para anmazenar dados do ID do AutoComplete escolhido

import React, { createContext, useState } from "react";

export const PacienteIdContext = createContext()
export const PacienteNomeContext = createContext()

export const PacienteContextProvider = ({ children }) => {
    const [pacienteIdContext, setPacienteIdContext] = useState('')
    const [pacienteNomeContext, setPacienteNomeContext] = useState('')
    // const [pacienteEstadoIdContext, setPacienteEstadoIdContext] = useState('')
    //const [pacienteCidadeIdContext, setPacienteCidadeIdContext] = useState('')

    return (
        <PacienteIdContext.Provider value={{ pacienteIdContext, setPacienteIdContext }}>
            <PacienteNomeContext.Provider value={{ pacienteNomeContext, setPacienteNomeContext }}>
                {/* <PacienteEstadoIdContext.Provider value={{ pacienteEstadoIdContext, setPacienteEstadoIdContext }}>
                    <PacienteCidadeIdContext.Provider value={{ pacienteCidadeIdContext, setPacienteCidadeIdContext }}>*/}
                {children}
                {/* </PacienteCidadeIdContext.Provider>
                    </PacienteEstadoIdContext.Provider> */}
            </PacienteNomeContext.Provider>
        </PacienteIdContext.Provider>
    )
}